import { Button, Text, Icon } from '@nimbus-ds/components';
import { ExternalLinkIcon } from '@nimbus-ds/icons';
import { Stack } from 'commons/components';
import useTranslationOnline from 'domains/Online/useTranslationOnline';
import DesignEditSectionContainer from './DesignEditSectionContainer';

type DesignEditSectionProps = Readonly<{
  onEditDesign: () => void;
}>;

export default function DesignEditSection({
  onEditDesign,
}: DesignEditSectionProps) {
  const t = useTranslationOnline('contentPages.formPage.designEditSection');

  return (
    <Stack column spacing="tight" align="stretch">
      <Stack.Item>
        <Stack
          column
          justify="flex-start"
          align="flex-start"
          spacing="extra-tight"
        >
          <Text fontSize="base" fontWeight="bold" textAlign="left">
            {t('title')}
          </Text>
          <Text
            fontSize="base"
            color="neutral-textLow"
            textAlign="left"
            lineHeight="base"
          >
            {t('description')}
          </Text>
        </Stack>
      </Stack.Item>

      <Stack.Item>
        <DesignEditSectionContainer>
          <Button as="button" appearance="primary" onClick={onEditDesign}>
            {t('button')}
            <Icon
              color="currentColor"
              source={<ExternalLinkIcon size="small" />}
            />
          </Button>
        </DesignEditSectionContainer>
      </Stack.Item>
    </Stack>
  );
}
